import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageUtil } from '@app/shared/utils/image.util.service';
import { BehaviorSubject } from 'rxjs';
import { LisitingCategory } from '@app/models/listing-category.model';
import { ListingCategoryService } from '@app/core/services/listing-category.service';
@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./results.component.css']
})

export class ResultsComponent implements OnInit {
  ranges = [[5, 10], [11, 20],
  [21, 30], [31, 40],
  [41, 50], [51, 60],
  [61, 70], [71, 80],
  [81, 90], [91, 100]]

  toppings = new FormControl();
  selectedDateRange: any;
  searchedValue: any;
  searchedListing: any;

  reservedDates: any;
  dates: any;

  toppingList: string[] = ['Bikes', 'Motor', 'Cars', 'Tech', 'Phone'];
  _currentValues: any;

  sortBy = '0';
  currentPage: number;
  hasNoMoreResults: boolean;
  results: any[];
  pageEvent$ = new BehaviorSubject<number>(1);
  minRentalPriceRange: any;

  categories: { source: LisitingCategory, checked: boolean }[] = [];


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private imageUtil: ImageUtil,
    public categoryService: ListingCategoryService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.searchedValue = data.searchedValue;
    });
    this.route.data.subscribe(data => {
      console.log('data', data);
      this.searchedListing = data.listing;
      // this.searchedListing = [];
      // for (let i = 0; i < 20; i++) {
      //   this.searchedListing.push(data.listing[0]);
      // }
    });

    this.categoryService.getParentCategories()
      .subscribe((res) => {
        this.categories = res.map(d => ({ source: d, checked: false }));
      }, (err) => {
        console.error(err);
      });

  }

  goToDetails(listingID) {
    this.router.navigate(['listing/details', listingID]);
  }

  /*Method to listen for onChange event from slider*/
  onSliderChange(selectedValues: number[]) {
    this._currentValues = selectedValues;
    if (!this._currentValues) {
      this._currentValues = 0;
    }

    if (this._currentValues >= 1000) {
      this._currentValues = Math.round(this._currentValues / 1000) + 'k';
    }
  }

  getBackgroundImageStyle(imageUrl: string) {
    return this.imageUtil.getBackgroundImageStyle(imageUrl);
  }

  changeDateRangeCal1(evt: any) {

  }

  resetValues(evt: any) {

  }

  invokeEvent() {
    const randNum = Math.random() * 2000;
    this.pageEvent$.next(randNum);
  }

  emitSortBy() {
    this.reset();
    this.invokeEvent();
  }

  reset() {
    this.currentPage = 0;
    this.hasNoMoreResults = false;
    this.results = [];
  }

  emitPriceRange(source) {
    this.minRentalPriceRange = source.min;
    this.minRentalPriceRange = source.max;
    this.reset();

    this.invokeEvent();
  }

  categoryChange(source) {
    this.reset();
    this.invokeEvent();
  }

}
